/* 
 * Inventory Message - Section Fetch Version
 * Gets inventory data from section rendering since window.product doesn't include quantities
 */

class InventoryMessage {
  constructor() {
    this.container = document.querySelector('.product__inventory-message');
    if (!this.container) return;
    
    this.lowThreshold = parseInt(this.container.dataset.lowThreshold) || 10;
    this.lowMessage = this.container.dataset.lowMessage || 'Only a few left';
    this.outMessage = this.container.dataset.outMessage || 'This item is sold out';
    this.variantCache = new Map();
    this.lastVariantId = null;
    
    this.init();
  }

  init() {
    // Cache initial variant data from the page
    this.cacheInitialVariant();
    
    // Start polling for variant changes
    setInterval(() => this.checkVariantChange(), 300);
    
    // Listen to clicks
    document.addEventListener('click', () => {
      setTimeout(() => this.checkVariantChange(), 100);
    });
  }

  cacheInitialVariant() {
    // Try to get initial variant data from the rendered snippet
    const initialVariantId = this.container.dataset.variantId;
    if (initialVariantId) {
      this.lastVariantId = parseInt(initialVariantId);
      // The initial message is already rendered by Liquid, so we don't need to do anything
    }
  }

  checkVariantChange() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    const variantId = parseInt(variantInput.value);
    
    if (variantId === this.lastVariantId) return;
    
    this.lastVariantId = variantId;
    this.fetchVariantData(variantId);
  }

  async fetchVariantData(variantId) {
    // Check cache first
    if (this.variantCache.has(variantId)) {
      this.updateMessage(this.variantCache.get(variantId));
      return;
    }

    try {
      // Get product handle from URL
      const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (!productHandle) return;

      // Fetch the section with the variant parameter
      // This will render the liquid template with the selected variant
      const sectionId = document.querySelector('product-info')?.dataset.section || 'main-product';
      const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
      
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the HTML to extract variant data
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the inventory message container in the fetched HTML
      const fetchedContainer = doc.querySelector('.product__inventory-message');
      
      if (fetchedContainer) {
        // Extract the rendered message
        const renderedMessage = fetchedContainer.innerHTML;
        
        // Cache it
        this.variantCache.set(variantId, renderedMessage);
        
        // Update the display
        this.updateMessage(renderedMessage);
      } else {
        // No container found, clear message
        this.updateMessage('');
      }
      
    } catch (error) {
      console.error('Error fetching variant data:', error);
    }
  }

  updateMessage(messageHTML) {
    // Fade out
    this.container.style.opacity = '0';
    
    setTimeout(() => {
      // Update content
      this.container.innerHTML = messageHTML;
      
      // Fade in
      this.container.style.opacity = '1';
    }, 300);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new InventoryMessage());
} else {
  new InventoryMessage();
}